<template>
  <v-container fluid>
    <v-col>
      <v-slide-y-transition mode="out-in">
        <v-row class="child-flex">
          <v-card>
            <v-card-text>
              <v-card-title>
                <v-col class="text-h4">Users</v-col>
                <v-spacer></v-spacer>
                <v-text-field
                  @keydown.native.escape="search=''"
                  label="Search"
                  clearable
                  single-line
                  hide-details
                  v-model="search"
                ></v-text-field>
              </v-card-title>
            </v-card-text>
            <v-data-table
              :headers="tableColumns"
              :items="queriedData"
              item-key="id"
              class="elevation-1"
            >
              <template v-slot:item.name="{ item }">
                  <span :class="item.enabled ? '' : 'disabled-user'">{{ item.name }}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="handleEdit(item)">mdi-pencil</v-icon>
                <!-- <v-icon small class="mr-2" @click="handleDisable(item)">mdi-account-off</v-icon> -->
              </template>
            </v-data-table>
          </v-card>
        </v-row>
      </v-slide-y-transition>
    </v-col>
    <v-btn fab bottom right color="pink" dark fixed :to="{'name': 'new_user_path'}">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('UserStore', {
      tableData: 'users'
    }),
    queriedData () {
      if (!this.search) {
        return this.tableData
      }
      let result = this.tableData.filter(row => {
        let isIncluded = false
        for (let key of this.propsToSearch) {
          let rowValue = row[key] ? row[key].toString() : ''
          if (
            rowValue.includes &&
            rowValue.toLowerCase().includes(this.search.toLowerCase())
          ) {
            isIncluded = true
          }
        }
        return isIncluded
      })
      return result
    }
  },
  data: function () {
    return {
      search: '',
      propsToSearch: ['name', 'email'],
      tableColumns: [
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'CognitoID', value: 'username' },
        { text: 'Status', value: 'user_status' },
        { text: 'MFA Setting', value: 'preferred_mfa' },
        { text: 'Actions', value: 'actions' }
      ]
    }
  },
  mounted: function () {
    this.$store.dispatch('getUserAttributes').catch(error => {
      this.$flash({
        showClose: true,
        message:
          'Error Loading Authenticated User Attributes. ' + error.message,
        type: 'error'
      })
    })
    return this.$store.dispatch('UserStore/fetchUsers').catch(error => {
      this.$flash({
        showClose: true,
        message: 'Error Loading Users. Reload to try again. ' + error.message,
        type: 'error'
      })
    })
  },
  methods: {
    handleDelete (row) {
      alert(`Your want to delete ${row.id}`)
    },
    handleEdit (item) {
      this.$router.push({ name: 'edit_user_path', params: { id: item.id } })
    }
  }
}
</script>

<style scoped>
  .disabled-user {
    text-decoration: line-through;
  }
</style>
